module.exports = require('../../full/instance/bind');
